@if (!isSVG()) {
    @if (type() === 'filled') {
        <i class="material-icons-sharp cux-icon {{size() | iconSize}} {{state() | iconState}}">
            {{name()}}
        </i>
    } @else {
        <i class="material-icons-outlined cux-icon {{size() | iconSize}} {{state() | iconState}}">
            {{name()}}
        </i>
    }
} @else {
    <img class="icon-svg" [src]="'../../../assets/icons/'+svgName()" [alt]="'Referencing icon for '+ svgName()">
}
